<style lang="less">
    .page-content {
        min-width: 180px;
    }
</style>
<i18n>
{
  "zh": {
    "unlock": "解除锁定",
    "pasteText": "粘贴",
    "selAllShape": "选中所有",
    "selectByType": "按类型选中",
    "selectByLayer": "按图层选中",
    "showGrid": "网格",
    "clearWatermark": "去水印",
    "showGuides": "参考线",
    "showRuler": "标尺",
    "margins": "页面边距",
    "showLine": "连接线交点样式",
    "addText": "添加文本",
    "addConnector": "添加连接线",
    "addGuideH": "添加水平参考线",
    "addGuideV": "添加垂直参考线",
    "fitDrawText": "页面适应到形状",
    "centerText": "居中",
    "showAIEntry": "打开亿图AI悬浮球",
    "hiddenAIEntry": "关闭亿图AI悬浮球"
  },
  "en": {
    "unlock": "UnLock",
    "pasteText": "Paste",
    "selAllShape": "Select All ",
    "selectByType": "Select by Type",
    "selectByLayer": "Select by Layer",
    "showGrid": "Grid",
    "clearWatermark": "Remove watermarks",
    "showGuides": "Guides",
    "showRuler": "Ruler",
    "margins": "Margins",
    "showLine": "Show Line Jumps",
    "addText": "Add Text",
    "addConnector": "Add Connector",
    "addGuideH": "Add Horizontal Guide",
    "addGuideV": "Add Vertical Guide",
    "fitDrawText": "Fit to Drawing",
    "centerText": "Center ",
    "showAIEntry": "Open Edraw AI floating ball",
    "hiddenAIEntry": "Close Edraw AI floating ball"
  },
  "fr": {
    "unlock": "Débloquer",
    "pasteText": "Coller",
    "selAllShape": "Sélectionner tout",
    "selectByType": "Sélectionner par type",
    "selectByLayer": "Sélectionner par couche",
    "showGrid": "Ligne de grille",
    "clearWatermark": "Supprimer les filigranes",
    "showGuides": "Des lignes directrices",
    "showRuler": "Afficher la règle",
    "margins": "Marges de page",
    "showLine": "Afficher des déviations de trait ",
    "addText": "Ajouter du texte",
    "addConnector": "Ajouter un connecteur",
    "addGuideH": "Ajouter un guide horizontal",
    "addGuideV": "Ajouter un guide vertical",
    "fitDrawText": "Ajuster au dessin",
    "centerText": "Centrer",
    "showAIEntry": "Ouvrir la bulle flottante Edraw AI",
    "hiddenAIEntry": "Fermer la bulle flottante Edraw AI"
  },
  "de": {
    "unlock": "Entsperren",
    "pasteText": "Eifügen",
    "selAllShape": "Alle auswählen",
    "selectByType": "Nach Typen auswählen",
    "selectByLayer": "Nach Ebene auswählen",
    "showGrid": "Gitternetz",
    "clearWatermark": "Wasserzeichen entfernen",
    "showGuides": "Führungslinien",
    "showRuler": "Lineal ",
    "margins": "Ränder",
    "showLine": "Liniensprünge anzeigen",
    "addText": "Text hinzufügen",
    "addConnector": "Verbinder hinzufügen",
    "addGuideH": "Horizontale Führungslinie hinzufügen",
    "addGuideV": "Vertikale Führungslinie hinzufügen",
    "fitDrawText": "Zeichnung anpassen",
    "centerText": "Zentrum",
    "showAIEntry": "Edraw AI-Zugriffshilfe öffnen",
    "hiddenAIEntry": "Edraw AI-Zugriffshilfe schließen"
  },
  "jp": {
    "unlock": "ロック解除",
    "pasteText": "貼り付け",
    "selAllShape": "すべてを選択",
    "selectByType": "タイプに応じて選択",
    "selectByLayer": "レイヤーに応じて選択",
    "showGrid": "グリッド",
    "clearWatermark": "透かしを削除",
    "showGuides": "ガイドライン",
    "showRuler": "ルーラー",
    "margins": "ページ余白",
    "showLine": "接続交差点に弧を表示",
    "addText": "テキストを追加",
    "addConnector": "コネクターを追加",
    "addGuideH": "水平ガイドラインを追加",
    "addGuideV": "垂直ガイドラインを追加",
    "fitDrawText": "図面に合わせる",
    "centerText": "中央揃え",
    "showAIEntry": "Edraw AIフローティングボールを開く",
    "hiddenAIEntry": "Edraw AIフローティングボールを閉じる"
  },
  "es": {
    "unlock": "Desbloquear",
    "pasteText": "Pegar",
    "selAllShape": "Seleccionar todo",
    "selectByType": "Seleccionar por Tipo",
    "selectByLayer": "Seleccionar por Capa",
    "showGrid": "Cuadrícula",
    "clearWatermark": "Eliminación de marcas de agua",
    "showGuides": "Guías",
    "showRuler": "Regla",
    "margins": "Márgenes",
    "showLine": "Mostrar saltos de línea",
    "addText": "Añadir Texto",
    "addConnector": "Añadir Conector",
    "addGuideH": "Añadir Guía horizontal",
    "addGuideV": "Añadir la guía vertical",
    "fitDrawText": "Ajustado al dibujo",
    "centerText": "Centrar",
    "showAIEntry": "Abrir la bola flotante de la IA de Edraw",
    "hiddenAIEntry": "Cerrar la bola flotante de la IA de Edraw"
  },
  "pt": {
    "unlock": "Desbloquear",
    "pasteText": "Colar",
    "selAllShape": "Selecionar tudo",
    "selectByType": "Selecionar por Tipo",
    "selectByLayer": "Selecionar por Camada",
    "showGrid": "Grelha",
    "clearWatermark": "Remover marcas d'água",
    "showGuides": "Guias",
    "showRuler": "Régua",
    "margins": "Limites",
    "showLine": "Mostrar Saltos de Linha",
    "addText": "Adicionar Texto",
    "addConnector": "Adicionar Conector",
    "addGuideH": "Adicionar Guia Horizontal",
    "addGuideV": "Adicionar Guia Vertical",
    "fitDrawText": "Ajustar ao Desenho",
    "centerText": "Centrar",
    "showAIEntry": "Abrir a bola flutuante do Edraw AI",
    "hiddenAIEntry": "Fechar a bola flutuante do Edraw AI"
  },
  "it": {
    "unlock": "Sblocca",
    "pasteText": "Incolla",
    "selAllShape": "Seleziona tutto",
    "selectByType": "Seleziona per Tipo",
    "selectByLayer": "Seleziona per Livello",
    "showGrid": "Griglia",
    "clearWatermark": "Rimuovi filigrana",
    "showGuides": "Guide",
    "showRuler": "Righelli",
    "margins": "Margini",
    "showLine": "Mostra Salti di Linea",
    "addText": "Aggiungi Testo",
    "addConnector": "Aggiungi Connettore",
    "addGuideH": "Aggiungi Guida Orizzontale",
    "addGuideV": "Aggiungi Guida Verticale",
    "fitDrawText": "Adatta al Disegno",
    "centerText": "Centra",
    "showAIEntry": "Apri sfera mobile Edraw AI",
    "hiddenAIEntry": "Chiudi sfera mobile Edraw AI"
  },
  "tw": {
    "unlock": "解除鎖定",
    "pasteText": "貼上",
    "selAllShape": "選中所有",
    "selectByType": "按類型選中",
    "selectByLayer": "按圖層選中",
    "showGrid": "網格",
    "clearWatermark": "移除浮水印",
    "showGuides": "參考線",
    "showRuler": "標尺",
    "margins": "頁面邊距",
    "showLine": "連接線交點樣式",
    "addText": "添加文本",
    "addConnector": "添加連接線",
    "addGuideH": "添加水平參考線",
    "addGuideV": "添加垂直參考線",
    "fitDrawText": "頁面適合到形狀",
    "centerText": "居中",
    "showAIEntry": "開啟 Edraw AI 浮球",
    "hiddenAIEntry": "關閉 Edraw AI 浮球"
  }
}
</i18n>
<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" @handleMouseenter="handleMouseenter(...arguments)" />
</template>

<script lang="ts">
    declare var eSelByType: any;
    declare var EDDocument: any;
    declare var eSnapFlags: any;
    declare var eJumpMode: any;
    declare var eToolType: any;
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class pageContext extends Vue {
        closeContext() {
            this.$store.commit("closeContext");
        }
        showExpand() {
            this.$store.commit("setStatus", {
                type: "showContextExpand",
                data: true,
            });
        }
        showExp(e: MouseEvent, type: string) {
            let node = <HTMLElement>e.target;
            let ts: any = this;
            ts.$bus.$emit("changeContextType", type, node.offsetTop - (<HTMLElement>node.parentElement).scrollTop);
            if (["rememberFontStyle", "selectByType", "selectByLayer", "grid", "guide", "margins", "lineJump"].includes(type)) {
                this.showExpand();
                ts.$bus.$emit("changeExpandPosition");
            }
        }
        unlocks(e: MouseEvent) {
            let view = window["_view"];
            if (!view) return;
            view.unlock(e);
            this.closeContext();
        }
        pastes(e: MouseEvent) {
            let view = window["_view"];
            if (!view) return;
            view.paste(e);
            this.closeContext();
        }
        toggleRuler() {
            let view = window["_view"];
            if (!view) return;

            let checked = !view._doc._config._showRuler;
            view.showRulersBox(checked);
            this.closeContext();
        }
        selAllShapes() {
            let view = window["_view"];
            if (!view) return;
            view.selectAll();
            this.closeContext();
        }
        clearWatermark() {
            this.$openBuyPage("removeVipTemplateMark");
        }
        // lineJump(){
        //     let view = window['_view'];
        //     if(!view) return;
        //     let checked = view._activePage._jumpMode === eJumpMode.Horizontal;
        //     view.showLineJumps(!checked);
        //     this.closeContext();
        // }

        addTexts() {
            window["_view"].addText();
            this.closeContext();
        }
        addConnector() {
            window["_view"]._tool.setType(eToolType.RightAngle);
            this.closeContext();
        }
        addGuideLines(bVertical) {
            window["_view"].addGuideLine(bVertical);
        }
        fitDraw() {
            let view = window["_view"];
            if (!view) return;
            view.fittoDrawing();
            this.closeContext();
        }
        center() {
            let view = window["_view"];
            if (!view) return;
            view.moveToCenter();
            this.closeContext();
        }

        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "unlock",
                    () => {
                        this.unlocks(event);
                    },
                ],
                [
                    "pasteText",
                    () => {
                        this.pastes(event);
                    },
                ],
                [
                    "selAllShape",
                    () => {
                        this.selAllShapes();
                    },
                ],
                [
                    "clearWatermark",
                    () => {
                        this.clearWatermark();
                    },
                ],
                [
                    "showRuler",
                    () => {
                        this.toggleRuler();
                    },
                ],
                [
                    "addText",
                    () => {
                        this.addTexts();
                    },
                ],
                [
                    "addConnector",
                    () => {
                        this.addConnector();
                    },
                ],
                [
                    "addGuideH",
                    () => {
                        this.addGuideLines(0);
                    },
                ],
                [
                    "addGuideV",
                    () => {
                        this.addGuideLines(1);
                    },
                ],
                [
                    "fitDrawText",
                    () => {
                        this.fitDraw();
                    },
                ],
                [
                    "centerText",
                    () => {
                        this.center();
                    },
                ],
                [
                    "hiddenAIEntry",
                    () => {
                        this.toggleEntry();
                    },
                ],
                [
                    "showAIEntry",
                    () => {
                        this.toggleEntry();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }

        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.showExp(event, key);
        }

        get showUnlock() {
            return this.$store.state.ui.onProtectShape;
        }
        get showRuler() {
            return this.$store.state.page.showRuler;
        }
        get isUsedVipState() {
            return this.$store.getters.isUsedVipState;
        }

        get menuList() {
            let list = [
                { key: "unlock", isRender: this.showUnlock },
                { key: "pasteText", expand: true, shortcut: "Ctrl+V", hasIcon: true },
                { divide: true },
                { key: "selAllShape", shortcut: "Ctrl+A" },
                { key: "selectByType", expand: true },
                { key: "selectByLayer", expand: true },
                { divide: true },
                { key: "showGrid", expand: true },
                { key: "clearWatermark", isRender: !this.vip && this.isUsedVipState, showVip: true, hideTippy: true },
                { key: "showGuides", expand: true },
                { key: "showRuler", checked: this.showRuler },
                { key: "margins", expand: true },
                { key: "showLine", expand: true },
                { divide: true },
                { key: "addText" },
                { key: "addConnector" },
                { key: "addGuideH" },
                { key: "addGuideV" },
                { divide: true },
                { key: "fitDrawText" },
                { key: "centerText" },
                { key: this.userShowAIBotEntry ? "hiddenAIEntry" : "showAIEntry", isRender: window.EDCONFIG.AI.ENABLE },
                // { key: "Duplicate" },
                // { key: "Delete" },
            ];

            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(item.divide ? item : Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "page-content", list: resultList };
        }
        get userShowAIBotEntry() {
            return this.$store.state.ui.userShowAIBotEntry;
        }
        set userShowAIBotEntry(v) {
            this.$store.commit("setStatus", {
                type: "userShowAIBotEntry",
                data: v,
            });
        }
        toggleEntry() {
            this.userShowAIBotEntry = !this.userShowAIBotEntry;
            this.closeContext();
        }

        mounted() {}

        created() {}
    }
</script>
